import WarehouseSystemCodeIndex from "@/components/billing/warehouse_system_code/WarehouseSystemCodeIndex.vue";
import WarehouseSystemCodeAdd from "@/components/billing/warehouse_system_code/WarehouseSystemCodeAdd.vue";
import WarehouseSystemCodeDetail from "@/components/billing/warehouse_system_code/WarehouseSystemCodeDetail.vue";
import WarehouseSystemCodeEdit from "@/components/billing/warehouse_system_code/WarehouseSystemCodeEdit.vue";
import WarehouseSystemCodeUpload from "@/components/billing/warehouse_system_code/WarehouseSystemCodeUpload.vue";

let routesWarehouseSystemCodeAccess= [
    {
        path: '',
        meta: {
          title: "List Warehouse System Code",
        },
        name: "WarehouseSystemCodeIndex",
        component: WarehouseSystemCodeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Warehouse System Code",
        },
        name: "WarehouseSystemCodeAdd",
        component: WarehouseSystemCodeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Warehouse System Code",
        },
        name: "WarehouseSystemCodeDetail",
        component: WarehouseSystemCodeDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Warehouse System Code",
        },
        name: "WarehouseSystemCodeEdit",
        component: WarehouseSystemCodeEdit
    },
    
    {
      path: 'upload',
      meta: {
        title: "Upload Warehouse System Code",
      },
      name: "WarehouseSystemCodeUpload",
      component: WarehouseSystemCodeUpload
  },
]

export default routesWarehouseSystemCodeAccess
  